export default "__VITE_ASSET__BWQG9Qri__"